import React, { useEffect, useReducer } from 'react';
import styled from 'styled-components';
import { VALIDATION_STATES } from '../../utils/constants';
import ComposedSelectField from '../ComposedField/ComposedSelectField';
import ComposedTextField from '../ComposedField/ComposedTextField';
import FirstName from '../Fields/FirstName';
import LastName from '../Fields/LastName';
import OrganizationName from '../Fields/OrganizationName';
import { ORGANIZATION_TYPES_OPTIONS } from '../../utils/registrationFormDropdownOptions';
import { breakpoints, GridContainer } from '@parchment/atoms';
const INITIAL_VALIDATION_STATE = {
  firstName: {
    state: VALIDATION_STATES.neutral
  },
  lastName: {
    state: VALIDATION_STATES.neutral
  },
  organizationName: {
    state: VALIDATION_STATES.neutral
  },
  organizationType: {
    state: VALIDATION_STATES.neutral
  },
  title: {
    state: VALIDATION_STATES.neutral
  }
};
const noop = () => undefined;
const VALIDATION_STATE_REDUCER = (prevState, updatedProperty) => ({
  ...prevState,
  ...updatedProperty
});
export default function ThirdPartyInformationGrid(_ref) {
  let {
    fieldProps,
    onChange = noop,
    onValidate = noop
  } = _ref;
  const wrapper = /*#__PURE__*/React.createRef();
  const [validationStates, setValidationStates] = useReducer(VALIDATION_STATE_REDUCER, INITIAL_VALIDATION_STATE);
  const {
    firstName,
    lastName,
    organizationName,
    organizationType,
    title
  } = fieldProps;
  useEffect(() => {
    const states = Object.values(validationStates).map(field => field.state);
    if (states.indexOf(VALIDATION_STATES.error) >= 0) {
      return onValidate(VALIDATION_STATES.error);
    } else if (states.indexOf(VALIDATION_STATES.neutral) >= 0) {
      return onValidate(VALIDATION_STATES.neutral);
    } else if (states.indexOf(VALIDATION_STATES.success) >= 0) {
      return onValidate(VALIDATION_STATES.success);
    }
  }, [validationStates]);
  return /*#__PURE__*/React.createElement(ThirdPartyInformationFormGrid, {
    ref: wrapper
  }, /*#__PURE__*/React.createElement(GridContainer, {
    className: "organization-information-grid"
  }, /*#__PURE__*/React.createElement(FirstName, {
    className: "first-name-field",
    label: "Your First Name",
    value: firstName,
    internalLabel: true,
    onChange: value => onChange(Object.assign(fieldProps, {
      firstName: value
    }), 'firstName'),
    onValidate: validationState => setValidationStates({
      firstName: {
        state: validationState
      }
    }),
    required: true
  }), /*#__PURE__*/React.createElement(LastName, {
    className: "last-name-field",
    label: "Your Last Name",
    value: lastName,
    internalLabel: true,
    onChange: value => onChange(Object.assign(fieldProps, {
      lastName: value
    }), 'lastName'),
    onValidate: validationState => setValidationStates({
      lastName: {
        state: validationState
      }
    }),
    required: true
  }), /*#__PURE__*/React.createElement(OrganizationName, {
    className: "organization-name-field",
    label: "Organization You Work For",
    value: organizationName,
    internalLabel: true,
    onChange: value => onChange(Object.assign(fieldProps, {
      organizationName: value
    }), 'organizationName'),
    onValidate: validationState => setValidationStates({
      organizationName: {
        state: validationState
      }
    }),
    width: "100%",
    required: true
  }), /*#__PURE__*/React.createElement(ComposedSelectField, {
    id: "organization-select",
    className: "organization-field",
    name: "organizationType",
    label: "Your Organization Type",
    value: organizationType,
    options: ORGANIZATION_TYPES_OPTIONS,
    onChange: value => onChange(Object.assign(fieldProps, {
      organizationType: value
    }), 'organizationType'),
    onValidate: validationState => setValidationStates({
      organizationType: {
        state: validationState
      }
    }),
    required: true
  }), /*#__PURE__*/React.createElement(ComposedTextField, {
    className: "title-field",
    name: "title",
    label: "Your Role / Job Title",
    value: title,
    internalLabel: true,
    onChange: value => onChange(Object.assign(fieldProps, {
      title: value
    }), 'title'),
    onValidate: validationState => setValidationStates({
      title: {
        state: validationState
      }
    }),
    required: true
  })));
}
const ThirdPartyInformationFormGrid = /*#__PURE__*/styled.div.withConfig({
  displayName: "ThirdPartyInformationGrid__ThirdPartyInformationFormGrid",
  componentId: "sc-1nebr72-0"
})([".first-name-field,.last-name-field,.organization-field,.title-field{width:100%;@media (min-width:", "){width:50%;}}"], breakpoints.mediumMin);